const broadcastTypes = {
    OBTRUSIVE: 'obtrusive',
    NON_OBTRUSIVE: 'nonObtrusive'
};
Object.freeze(broadcastTypes);
export default broadcastTypes;